import { render, staticRenderFns } from "./BoxSearch.vue?vue&type=template&id=775927e5&scoped=true&"
import script from "./BoxSearch.vue?vue&type=script&lang=js&"
export * from "./BoxSearch.vue?vue&type=script&lang=js&"
import style0 from "./BoxSearch.vue?vue&type=style&index=0&id=775927e5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775927e5",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/Settings/BoxSearch.vue
// module id = 930
// module chunks = 0